import React, { FC, useState } from 'react';
import Input from 'components/Input';
import ModalComponent from 'components/Modal';
import { ViewType } from '~/pages/Reports/Submissions/types';
import './style.scss';

export interface ModalViewProps {
  actionLabel: string;
  initialViewName: string;
  handleOnSaveView: (viewName: string) => Promise<void>;
  loadingSaveView: boolean;
  showModal: boolean;
  setShowModal: (view: ViewType | undefined) => void;
}

const Modal: FC<ModalViewProps> = ({
  handleOnSaveView,
  loadingSaveView,
  showModal,
  setShowModal,
  actionLabel,
  initialViewName,
}) => {
  const [viewName, setViewName] = useState(initialViewName);

  return (
    <ModalComponent
      header={actionLabel}
      headerIcon="reports"
      handleOnCancel={() => setShowModal(undefined)}
      handleOnConfirm={() => void handleOnSaveView(viewName)}
      confirmlabel={loadingSaveView ? 'Loading...' : actionLabel}
      denyLabel="Not now"
      visible={showModal}
      className="new-view-modal"
      confirmButtonProps={{ disabled: loadingSaveView }}>
      <div>
        <Input
          placeholder="E.g. Annual Fundraising"
          onChange={({ target }) => setViewName(target.value)}
          name="view_name"
          value={viewName}
        />
      </div>
    </ModalComponent>
  );
};

export default Modal;
